const KEY = 'tctp:sound';

/** 0 = off, 1 = small, 2 = medium, 3 = large. */
export type SoundLevel = 0 | 1 | 2 | 3;
const GAIN: Record<SoundLevel, number> = { 0: 0, 1: 0.35, 2: 0.65, 3: 1 };

export function soundLevel(): SoundLevel {
  try {
    const v = localStorage.getItem(KEY);
    if (v === 'off') return 0;           // the old on/off preference
    if (v === null || v === 'on') return 3;
    const n = Number(v);
    return n === 0 || n === 1 || n === 2 ? n : 3;
  } catch { return 3; }
}

export function setSoundLevel(level: SoundLevel): void {
  try { localStorage.setItem(KEY, String(level)); } catch { /* storage unavailable: preference is per page load */ }
}

/** Off → small → medium → large → off. Returns the new level. */
export function cycleSoundLevel(): SoundLevel {
  const next = ((soundLevel() + 1) % 4) as SoundLevel;
  setSoundLevel(next);
  return next;
}

/** Multiplier applied to every sound's gain. */
export function soundGain(): number {
  return GAIN[soundLevel()];
}

export function soundEnabled(): boolean {
  return soundLevel() > 0;
}

export function setSoundEnabled(on: boolean): void {
  setSoundLevel(on ? 3 : 0);
}
